module.exports = __webpack_public_path__ + "static/media/smartflow.7dddee95.png";